import React, { useContext, useEffect, useState } from "react";

import style from "./SelectLanding.module.css";
import axios from "axios";
import { UserContext } from "../../../../Context/UserContextProvider";

export default function SelectLandingModel(props){
    let [landings, setLandings] = useState([]);
    const { userToken, permissions, consultantData, userData } = useContext(UserContext);
    let [checkedLandings, setCheckedLandings] = useState([]);

    useEffect(() => {
        axios.get("Landing").then((res) => {
            setLandings(res.data);
            axios.get("Landing/EstateLandings?id=" + props.id).then((res) => {
                setCheckedLandings(res.data || []);
            });
        });
    }, [props]);

    function checkLanding(id){
        let cache = [...checkedLandings];

        if (cache.includes(id)){
            let newCache = [];

            cache.forEach((c) => {
                if (c == id){
                    return;
                }
                newCache.push(c);
            });
            
            axios.put("Landing/RemoveEstateLandings", {
                estateId: props.id,
                landings: id
            }, {
                headers: {
                    authorization: "Bearer " + userToken
                }
            }).then((res) => {
                setCheckedLandings(newCache);
            });
            return;
        }
        axios.put("Landing/AddEstateLandings", {
            estateId: props.id,
            landings: id
        }, {
            headers: {
                authorization: "Bearer " + userToken
            }
        }).then((res) => {
            setCheckedLandings([...cache, id]);
        });
    }

    function submitHandle(){
        /*axios.put("Landing/SetEstateLandings", {
            estateId: props.id,
            landings: checkedLandings
        }, {
            headers: {
                authorization: "Bearer " + userToken
            }
        });*/

        props.close();
    }


    return <div className={`${style.container}`} hidden={props.hidden}>
        <div className={`${style.main_container}`}>
            <div className={`${style.header}`}>
                <div className={`${style.title}`}>
                    ویرایش لندینگ های فایل
                </div>
                <div className={`${style.close_icon}`} onClick={() => {props.close()}}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{width: "20px", height: "20px"}}><path d="M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6C33.9 30.4 18.7 29.1 8.6 37.6S-2.9 61.3 5.6 71.4L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3 341.6 471.4c8.5 10.1 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z"/></svg>
                </div>
            </div>
            <div className={`${style.body}`}>
                {
                    landings.map((landing) => {
                        return  <div className={`${style.body_item}`}>
                                    <input type="checkbox" className={`${style.body_item_checkbox}`} checked={checkedLandings.includes(landing.id)} onChange={() => {checkLanding(landing.id)}}></input>
                                    <div className={`${style.body_item_title}`}>
                                        {landing.title}
                                     </div>
                                </div>
                    })
                }
            </div>
            <div className={`${style.footer}`}>
                <div className={`${style.submit}`} onClick={() => {submitHandle()}}>
                    ثبت
                </div>
                <div className={`${style.cancel}`} onClick={() => {props.close()}}>
                    لغو
                </div>
            </div>
        </div>
    </div>
}